import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['visitor', 'visitor-view', 'grid--vertical'])
}
const _hoisted_2 = { style: {"margin-bottom":"15px"} }
const _hoisted_3 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_visitor_information = _resolveComponent("visitor-information")!
  const _component_host_information = _resolveComponent("host-information")!
  const _component_visitor_list = _resolveComponent("visitor-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_visiting_companies, {
        records: _ctx.visitCompanies,
        editable: _ctx.mode == 'edit'
      }, null, 8, ["records", "editable"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_visitor_information, {
        ref: "visitorInformation",
        model: _ctx.model
      }, null, 8, ["model"]),
      _createVNode(_component_host_information, { model: _ctx.model }, null, 8, ["model"])
    ]),
    _createVNode(_component_visitor_list, {
      ref: "visitorList",
      view: _ctx.mode != 'edit'
    }, null, 8, ["view"])
  ]))
}